import { combineReducers } from 'redux';

import selectedSchoolIndexReducer from './selectedSchool';

const rootReducer = combineReducers({
    selectedSchoolIndexState: selectedSchoolIndexReducer,
});

export default rootReducer;
